import { getter } from '@progress/kendo-react-common';

const emailRegex = new RegExp(/^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
const phoneRegex = new RegExp(/^[0-9 ()+-]+$/);
const ccardRegex = new RegExp(/^[0-9-]+$/);
const cvcRegex = new RegExp(/^[0-9]+$/);
const numericRegex = new RegExp(/^[0-9]+$/);
const alphaNumericRegex = new RegExp(/^[a-zA-Z0-9 ]*$/);
const specialCharRegex = new RegExp(/[`!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/);
const nametoAppearRegex =new RegExp(/^[a-zA-Z0-9 \-.]+$/);
const bizNameSpecCharRegex = new RegExp(/^[a-zA-Z0-9 \-.,/&']+$/);
const addressRegex = new RegExp(/^[A-Za-z0-9\s'-]+$/);
// const pdfFileNameRegex = new RegExp(/[!#$&*]/);
const profitLossRegex = new RegExp(/^[0-9.-]+$/);
const annualRevenueRegex = new RegExp(/^[0-9.]+$/);
const decimalRegex = new RegExp(/^[0-9]*(\.[0-9]{0,2})?$/);
const spaceRegex = new RegExp(/\s/);


export const zeroDecimalValidator = (value) => !value? "Input numeric characters":decimalRegex.test(value) ===false?"Input numeric only.":(value <= 0)?'Input should be more than 0.00':'';
export const decimalValidator = (value) => !value? "Input numeric characters":decimalRegex.test(value) ===false?"Input numeric only":"";
export const myPostalCodeValidator = (value) => !value ? "Input the blank field (Postal Code)" :alphaNumericRegex.test(value) ===false? "Input max 16 alphanumeric characters": "";
export const stateValidator = (value) => !value ? "Input the blank field (State)":"";
export const cityValidator = (value) => !value ? "Input the blank field (City)" : "";
export const addline1Validator = (value) => !value ? "Input the blank field (Address Line 1)":"";
export const min200KValidator = (value) => !value? "Input the blank field":decimalRegex.test(value) ===false?"Input decimal only.":(value < 200000 || value > 10000000)?'Input Min.S$ 200,000 - Max.S$ 10,000,000':'';
export const min20KValidator = (value) => !value? "Input the blank field":decimalRegex.test(value) ===false?"Input decimal only.":(value < 20000 || value > 10000000)?'Input Min.S$ 20,000 - Max.S$ 10,000,000':'';
export const reqDayValidator = (value) => value ? "" : "Select day";
export const reqMonthValidator = (value) => value ? "" : "Select month";
export const reqYrValidator = (value) => value ? "" : "Select year";
export const refNoValidator = (value) => value ? "" : "Input the blank field (Reference No.)";
export const nricValidator = (value) => value ? "" : "Input the blank field (NRIC/FIN)";
export const uenValidator = (value) => value ? "" : "Input the blank field (UEN)";
export const tinValidator = (value) => !value? "Input the blank field (Tax Identification Number)": alphaNumericRegex.test(value) ===false?"Input max 20 alphanumeric characters":"";
export const tinRNoValidator = (value) => value? alphaNumericRegex.test(value) ===false?"Input max 20 alphanumeric characters":"":"";
export const taxReasonValidator = (value) =>!value?"Input the blank field (If TIN is unavailable, the reason is)": alphaNumericRegex.test(value) ===false? "Input max 100 alphanumeric characters":"";
export const reqDDLValidator = (value) => value ? "" : "Select drop down list";
export const requiredValidator = (value) => value ? "" : "Input the blank field";
export const blockValidator = (value) => !value ? "Input the blank field (Block)" : alphaNumericRegex.test(value) ===false? "Input max 10 alphanumeric characters" : value.length > 10 ? "Input max 10 characters":"";
export const streetValidator = (value) => !value ? "Input the blank field (Street)" :addressRegex.test(value) ===false? "Input max 66 alphanumeric characters": value.length > 66 ? "Input max 66 characters":"";
export const addressValidator = (value) => !value ? "Input the blank field (Address)" :alphaNumericRegex.test(value) ===false? "Input max 66 alphanumeric characters": value.length > 66 ? "Input max 66 characters":"";
export const postOfficeValidator = (value) => !value ? "Input the blank field (Post Office)" :alphaNumericRegex.test(value) ===false? "Input max 66 alphanumeric characters": value.length > 66 ? "Input max 66 characters":"";
export const lockBagValidator = (value) => !value ? "Input the blank field (Locked Bag No.)" : alphaNumericRegex.test(value) ===false? "Input max 10 alphanumeric characters" : value.length > 10 ? "Input max 10 characters":"";
export const storeyValidator = (value) => !value ? "Input the blank field (Storey No.)" : alphaNumericRegex.test(value) ===false? "Input max 3 alphanumeric characters" : value.length > 3 ? "Input max 3 characters":"";
export const godownValidator = (value) => !value ? "Input the blank field (Godown No.)" : alphaNumericRegex.test(value) ===false? "Input max 6 alphanumeric characters" : value.length > 6 ? "Input max 6 characters":"";
export const lotMukimValidator = (value) => !value ? "Input the blank field (Lot/Mukim No.)" : alphaNumericRegex.test(value) ===false? "Input max 6 alphanumeric characters" : value.length > 6 ? "Input max 6 characters":"";
export const boxNoValidator = (value) => !value ? "Input the blank field (Box No.)" : alphaNumericRegex.test(value) ===false? "Input max 10 alphanumeric characters" : value.length > 10 ? "Input max 10 characters":"";
export const houseNoValidator = (value) => !value ? "Input the blank field (House No.)" : alphaNumericRegex.test(value) ===false? "Input max 6 alphanumeric characters" : value.length > 6 ? "Input max 6 characters":"";
export const unitNoValidator = (value) => !value ? "Input the blank field (Unit No.)":alphaNumericRegex.test(value) ===false? "Input max 6 alphanumeric characters" :value.length > 6 ? "Input max 6 alphanumeric characters":"";
export const buildingValidator = (value) => !value ? "Input the blank field (Building)" : addressRegex.test(value) ===false?"Input max 66 alphanumeric characters": value.length > 66 ? "Input max 66 alphanumeric characters":"";
export const winDeliValidator = (value) => !value ? "Input the blank field (Window Delivery No.)":alphaNumericRegex.test(value) ===false? "Input max 6 alphanumeric characters" :value.length > 6 ? "Input max 6 alphanumeric characters":"";
export const postalCodeValidator = (value) => {
    try{
        if(!value) {
            return "Input the blank field (Postal Code)";
        }
        else if (!numericRegex.test(value)) {
            return "Input max 6 numeric characters";
        }
        else if(value.length > 6){
            return "Input max 6 numeric characters";
        }
    }catch(ex){

    }
   
}

export const levelValidator = (value) => {
    if(value) {
        if(!numericRegex.test(value)) {
            return 'Input max 3 numeric characters';
        }
        else if(value.length > 3) {
            return 'Input max 3 numeric characters';
        }
    }
}  
export const numericValidator = (value) => !value ? "Input numeric characters":numericRegex.test(value)===false?"Input numeric characters":"";
export const nameValidator = (value) => value ? "" : "Input the blank field (Name)";
export const transBankValidator =  (value) => !value ? "Input the blank field (Transfer from other banks)": alphaNumericRegex.test(value) ===false?"Input numeric characters":"";
export const othAlphaNumValidator =  (value) => !value ? "Input the blank field (Others)": alphaNumericRegex.test(value) ===false?"Input max 80 alphanumeric characters":"";
export const mobileNoValidator = (value) => !value ? "Input the blank field (Mobile No)":value.length < 8? "Input 8 digit mobile number":value.includes('+65')?"Input 8 digit mobile number, excluding +65":numericRegex.test(value)===false? "Input 8 digit mobile number":"";
export const othersInputValidator =  (value) => !value ? "Input the blank field (Others)": value.length <= 80 ? "": "Input max 80 characters";
export const suffixValidator = (value) => value? value.length < 3? "Input 3 alphanumeric characters": specialCharRegex.test(value)? "Input 3 alphanumeric characters" :'':'';
export const nameOnCardValidator = (value) => {
    if(!value){
       return "Input the blank field (Business Name to appear on card)"
    }
    else if(value.length > 19) {
       return "Input max 19 characters including space"
    }
    else if(bizNameSpecCharRegex.test(value) === false){
        return "Input name in correct format, limited to comma (,), full stop (.), slash (/), and (&), apostrophe (‘), dash (-) only."
    }
}
export const nametoAppearValidator = (value) => {
    if(!value){
       return "Input the blank field (Name to appear on card), 19 characters in total"
    }
    else if(value.length > 19) {
       return "Input max 19 characters including space"
    }
    else if(nametoAppearRegex.test(value) === false){
        return "Input name in correct format, limited to full stop (.) and dash (-) only.";
    }
}

export const profitLossValidator = (value) => {
    if(!value) {
        return "Input the blank field (Profit or Loss before tax)";
    }
    else if(profitLossRegex.test(value) === false){
        return "Please input numeric value only";
    }
}

export const annualRevenueValidator = (value) => {
    if(!value) {
        return "Input the blank field (Annual Revenue)";
    }
    else if(annualRevenueRegex.test(value) === false){
        return "Please input numeric value only";
    }
}

export const islamicFTypeValidator = (value) => value? "":"Please declare islamic fiancing type."
export const previewValidator = (value) => value? "":"Please certify"
export const uploadTermsValidator = (value) => value ? "" : "Please certify the document(s) uploaded above as true copy";
export const certBoardResoValidator = (value) => value? "":"Please certify Board Resolution"
export const termsValidator = (value) => value ? "" : "Please select Tax Declaration to proceed";
export const emailValidator = (value) => !value ?
    "Input the blank field (Email)" : value.length <= 60? 
    (emailRegex.test(value) ? "" : "Input valid email address format"):"Input max 60 characters";
    
 
export const userNameValidator = (value) => !value ?
    "User Name is required" :
    value.length < 5 ? "User name should be at least 3 characters long." : "";
export const phoneValidator = (value) => !value ?
    "Phone number is required." :
    phoneRegex.test(value) ? "" : "Not a valid phone number.";
export const cardValidator = (value) => !value ?
    "Credit card number is required. " :
    ccardRegex.test(value) ? "" : "Not a valid credit card number format.";
export const cvcValidator = (value) => !value ?
    "CVC code is required," :
    cvcRegex.test(value) || value.length !== 3 ? "" : "Not a valid CVC code format.";
export const guestsValidator = (value) => !value ?
    "Number of guests is required" :
    value < 5 ? "" : "Maximum 5 guests";
export const nightsValidator = (value) => value ? "" : "Number of Nights is required";
export const colorValidator = (value) => value ? "" : "Color is required.";
export const passwordValidator = (value) => value && value.length > 8 ? '' : 'Password must be at least 8 symbols.';

const userNameGetter = getter('username');
const emailGetter = getter('email');

export const formValidator = (values) => {
    const userName = userNameGetter(values);
    const emailValue = emailGetter(values);

    if (userName && emailValue && emailRegex.test(emailValue)) {
        return {};
    }

    return {
        VALIDATION_SUMMARY: 'Please fill the following fields.',
        ['username']: !userName ? 'User Name is required.' : '',
        ['email']: emailValue && emailRegex.test(emailValue) ? '' : 'Email is required and should be in valid format.'
    };
};

export const noSgdEquTxnsValidator = (value) => {
 
    if(!value){
        return "Input the blank field (Others)";
    }
    else if(!numericRegex.test(value)) {
        return 'Input max 15 numeric characters, without SGD';
    }
    else if(value === 0 || value === '0') {
        return 'Input non zero value, up to 15 numeric characters without SGD'
    }
}  

export const noTxnsValidator = (value) => {
    if(!value) {
        return "Input the blank field (Others)";
    }
    else if(!numericRegex.test(value)){
        return 'Input max 10 numeric characters';
    }
    else if(value === 0 || value === '0'){
        return 'Input non zero value, up to 10 numeric characters';
    }
}

export const totalFAmtValidator = (value) => {
    console.log('value',value);
}

export const leaseholdDateValidator = (value) => {
    const minDate = new Date(1900,0,1);
    const todayDate = new Date();

    if(value === undefined || value === null){
        // console.log('value null');
        return "Input the blank field (Leasehold Effective Date)"
    }
    else if(value < minDate) {
        // console.log('invalid value');
        return 'Input valid date (Leasehold Effective Date)'
    }
    else if (value >= todayDate) {
        // console.log('future value');
        return "Leasehold effective date cannot be in the future";
    }
    else {
        // console.log('no issue')
        return '';
    }
 
    // else if (value >= todayDate) {
    //     return "Leasehold Effective Date should not be future-dated.";
    // } else {
    //     return "";
    // }
}

export const bankAcctNoValidator = (value) => {
    // console.log('bankAcctNoValidator value',value)
    if(value === '') {
        return "Input the blank field (Account Number)"
    }
}

export const max10decimalValidator = (value) => {
 
    if(value > 9999999999) {
        return "Input max 10 numeric characters";
    }
    return '';
}

export const allowZeroNumericValidator = (value) => {
   
    if(value) {
        if(value < 0) {
            
            return 'Input numeric characters';
        }
        else {
        
            return '';
        }
    }
    else {
        if(value === 0) {
            return '';
        }
        return 'Input numeric characters';
    }
}

export const spaceValidator = (value) => {
    if(value) {
        if(spaceRegex.test(value)) {
            return 'Input with no space.'
        }
        return '';
    }
    return '';
}
 

 